import React, { useEffect, useState } from "react";
import FontIcon from "react-md/lib/FontIcons";
import "../styles/expandableTable.css";
import "../styles/cityTable.css";
import NoRecordsIcon from "../../../../../assets/icons/no-records.png";
import { Button } from "react-md";
import filterApplied from "../../../../../assets/icons/filter-applied-icon.svg";
import funnelIcon from "../../../../../assets/icons/funnel.svg";
import goIcon from "../../../../../assets/icons/right_arrow_go_btn.svg";
import GlobalSkeletonLoader from "../../../../../components/common/GlobalSkeletonLoader";
import {
  TextField,
  MenuItem,
  Menu,
  Select,
  IconButton,
  Radio,
} from "@material-ui/core";
import DeleteIcon from "react-md-icon/dist/OutlineDelete";
import Autocomplete from "@material-ui/lab/Autocomplete";

import { Col, Row } from "react-flexbox-grid";

const CityTable = ({
  loading,
  tableData,
  newTableData,
  handleUpdateNewTableData,
  handleUpdateTableData,
  cityMappingOperationSelected,
  cityMappingFilters,
  cityMappings,
  fetchCityMappings,
  providerToCreate,
  pageNum = cityMappings?.pageNo ?? 0,
  pageSize = cityMappings?.pageSize ?? 0,
  totalCount = cityMappings?.totalCount ?? 0,
}) => {
  const [expandedRowId, setExpandedRowId] = useState(null); // state to track expanded row
  const [anchorEl, setAnchorEl] = useState(null);
  const [menuFor, setMenuFor] = useState({});
  const [serviceProviderId, setServiceProviderId] = useState("");
  const [filterObj, setFilterObj] = useState({});
  const [openFilter, setOpenFilter] = useState(false);
  const [openBackdrop, setOpenBackdrop] = useState(false);

  useEffect(() => {
    console.log("tableData recvd in city table: ", tableData);
    console.log("newTableData recvd in city table: ", newTableData);
  }, []);

  const allStatusList = [
    { value: 1, name: "Active" },
    { value: 2, name: "Inactive" },
  ];

  const stringToInt = (str) => {
    const num = parseInt(str, 10); // Convert string to integer with base 10
    return isNaN(num) ? null : num; // Check if conversion failed
  };

  const getStatusName = (status) => {
    if (status == 1) {
      return "Active";
    } else if (status == 2) {
      return "Inactive";
    } else if (status == 3) {
      return "Deleted";
    }
    return "";
  };

  const navigateToNextPage = () => {
    if (pageNum * pageSize < totalCount) {
      fetchCityMappings(
        providerToCreate?.id,
        pageNum + 1,
        cityMappingFilters ?? {}
      );
      // setPageNum((prevPageNum) => prevPageNum + 1);
    }
  };
  const navigateToPrevPage = () => {
    if (pageNum > 1) {
      fetchCityMappings(
        providerToCreate?.id,
        pageNum - 1,
        cityMappingFilters ?? {}
      );
    }
  };

  return (
    <div className="navigo-appoint-container">
      <div className="navigo-appoint-section-5-cityTable">
        <div className="navigo-appoint-section-5-grid-container-cityTable">
          <div className="navigo-appoint-section-5-grid-container-common-section-cityTable">
            <p>City</p>
            <img
              src={
                (cityMappingFilters?.name ?? "").length > 0
                  ? filterApplied
                  : funnelIcon
              }
              onClick={() => {
                setOpenBackdrop(true);
                setOpenFilter(1);
              }}
            />
            {/* {openFilter === 1 && (
              <div className="navigo-appoint-section-5-grid-container-section-common-filter-popup">
                <Autocomplete
                  multiple
                  id="appointment-dialog-client-code-filter"
                  className="appointment-dialog-client-code-filter-class"
                  disableCloseOnSelect
                  options={[
                    ...(searchText ? [`Select all with "${searchText}"`] : []),
                    ...services.filter((service) =>
                      service.name
                        .toLowerCase()
                        .includes(searchText.toLowerCase())
                    ),
                  ]}
                  value={typeFilterValue}
                  onInputChange={(e, value) => {
                    setSearchText(value);
                  }}
                  onChange={(e, v) => {
                    if (v.includes(`Select all with "${searchText}"`)) {
                      const allMatchingOptions = services.filter((service) =>
                        service.name
                          .toLowerCase()
                          .includes(searchText.toLowerCase())
                      );
                      setTypeFilterValue(allMatchingOptions);
                      setTypeFilter(true);
                    } else {
                      setTypeFilterValue(v);
                      setTypeFilter(v.length > 0);
                    }
                  }}
                  getOptionLabel={(option) =>
                    typeof option === "string" ? option : option.name
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder={"Enter the service name"}
                    />
                  )}
                />
              </div>
            )} */}
          </div>
          <div className="navigo-appoint-section-5-grid-container-common-section-cityTable">
            <p>External city ID</p>
          </div>
          <div className="navigo-appoint-section-5-grid-container-common-section-cityTable">
            <p>External centre ID</p>
          </div>
          <div className="navigo-appoint-section-5-grid-container-common-section-cityTable">
            <p>Status</p>
            <img
              src={
                (cityMappingFilters?.status ?? []).length > 0
                  ? filterApplied
                  : funnelIcon
              }
              onClick={() => {
                setOpenBackdrop(true);
                setOpenFilter(5);
                // setOpenStatusFilter(true);
              }}
            />
            {openFilter === 5 && (
              <div className="navigo-appoint-section-5-grid-container-section-common-filter-popup">
                <Autocomplete
                  multiple
                  id="appointment-dialog-client-code-filter"
                  className="appointment-dialog-client-code-filter-class"
                  options={allStatusList}
                  value={cityMappingFilters?.status ?? []} //statusFilterValue
                  onChange={(e, v) => {
                    if (v.length > 0) {
                      fetchCityMappings(providerToCreate?.id, pageNum, {
                        ...cityMappingFilters,
                        status: v ?? [],
                      });
                      // setStatusFilterValue(v);
                      // setStatusFilter(true);
                    } else {
                      fetchCityMappings(providerToCreate?.id, pageNum, {
                        ...cityMappingFilters,
                        status: [],
                      });
                      // setStatusFilterValue([]);
                      // setStatusFilter(false);
                    }
                  }}
                  getOptionLabel={(option) => {
                    return option.name;
                  }}
                  renderInput={(params) => (
                    <TextField {...params} placeholder={"Type status name"} />
                  )}
                />
              </div>
            )}
          </div>
          <div></div>
        </div>
      </div>
      <div className="navigo-appoint-section-6">
        {Boolean((cityMappings?.cityEntities ?? []).length > 0) && (
          <div className="navigo-appoint-bottom-bar">
            <Button
              onClick={() => {
                navigateToPrevPage();
              }}
              disabled={pageNum <= 1 || loading}
            >
              <FontIcon>arrow_left</FontIcon>
            </Button>
            <div style={{ display: "flex", flexDirection: "row" }}>
              Showing&nbsp;
              <span
                style={{
                  color: "#ef7c01",
                  display: "flex",
                  flexDirection: "row",
                }}
              >
                {totalCount == 0 ? 0 : (pageNum - 1) * pageSize + 1}&nbsp;
              </span>
              <span
                style={{
                  color: "#ef7c01",
                  display: "flex",
                  flexDirection: "row",
                }}
              >
                - &nbsp;
                {totalCount > pageNum * pageSize
                  ? pageNum * pageSize
                  : totalCount}
              </span>
              <span>&nbsp;&nbsp;of&nbsp;</span>
              <span>{` ${totalCount}`}</span>
            </div>
            <Button
              onClick={() => {
                navigateToNextPage();
              }}
              disabled={
                loading ||
                pageNum * pageSize > totalCount ||
                (totalCount > pageNum * pageSize
                  ? pageNum * pageSize
                  : totalCount) == totalCount
              }
            >
              <FontIcon>arrow_right</FontIcon>
            </Button>
          </div>
        )}
        <div className="navigo-appoint-section-6-list-cityTable">
          {Boolean(
            (newTableData?.length ?? 0) > 0 &&
              cityMappingOperationSelected === 1
          ) &&
            (newTableData ?? []).map((ele, idx) => {
              return (
                <div
                  className="navigo-appoint-section-6-grid-container-cityTable"
                  key={ele?.id ?? idx}
                  style={{
                    backgroundColor: "#6A5EF51A",
                  }}
                >
                  <div className="general-font-class">{ele?.city ?? "-"}</div>
                  <div className="general-font-class">
                    {ele?.externalCityId ?? "-"}
                  </div>
                  <div className="general-font-class">
                    {ele?.externalCentreId ?? "-"}
                  </div>
                  <div className="navigo-appoint-section-6-grid-status">
                    {
                      <Select
                        disabled={false}
                        labelId="navigo-appoint-status-select"
                        id="navigo-appoint-status-select-id"
                        value={ele?.status ?? -1}
                        onChange={(e) => {
                          let elem = { ...ele };
                          if (elem?.status) {
                            elem.status = e.target.value;
                            handleUpdateNewTableData(elem, ele); // 1st param is for new object, and 2nd is for old object
                          }
                        }}
                        label="Status"
                        className={`navigo-dashboard-select-css navigo-status-selector ${`${
                          ele?.status === 1
                            ? "closed-class"
                            : `${
                                ele?.status === 2
                                  ? "invalid-class"
                                  : "progress-class"
                              }`
                        }`}`}
                      >
                        <MenuItem
                          value={1}
                          style={{
                            borderBottom: "1px solid #d8d8d8",
                            borderTopLeftRadius: "8px",
                            borderTopRightRadius: "8px",
                            fontWeight: "600",
                            paddingLeft: "5px",
                            fontFamily: "Montserrat",
                          }}
                          disabled={false}
                        >
                          Active
                        </MenuItem>
                        <MenuItem
                          value={2}
                          style={{
                            borderBottom: "1px solid #d8d8d8",
                            borderTopLeftRadius: "8px",
                            borderTopRightRadius: "8px",
                            fontWeight: "600",
                            paddingLeft: "5px",
                            fontFamily: "Montserrat",
                          }}
                          disabled={false}
                        >
                          Inactive
                        </MenuItem>
                      </Select>
                    }
                  </div>

                  <IconButton
                    onClick={(e) => {
                      if (handleUpdateNewTableData != null) {
                        let elem = { ...ele };
                        if (elem?.status) {
                          elem.status = 3;
                          handleUpdateNewTableData(elem, ele); // 1st param is for new object, and 2nd is for old object
                        }
                      }
                    }}
                    className="navigo-appoint-section-6-grid-edit-call"
                  >
                    <DeleteIcon
                      style={{
                        // fontSize: "10em",
                        color: "orange",
                      }}
                    />
                  </IconButton>
                </div>
              );
            })}
          {Boolean((tableData?.length ?? 0) > 0) &&
            (tableData ?? []).map((ele, idx) => {
              return (
                <div
                  className="navigo-appoint-section-6-grid-container-cityTable"
                  key={ele?.id ?? idx}
                  style={{
                    backgroundColor: "white",
                  }}
                >
                  <div className="general-font-class">{ele?.city ?? "-"}</div>
                  <div className="general-font-class">
                    {ele?.externalCityId ?? "-"}
                  </div>
                  <div className="general-font-class">
                    {ele?.externalCentreId ?? "-"}
                  </div>
                  <div className="navigo-appoint-section-6-grid-status">
                    {
                      <Select
                        disabled={cityMappingOperationSelected !== 2}
                        labelId="navigo-appoint-status-select"
                        id="navigo-appoint-status-select-id"
                        value={ele?.status ?? -1}
                        onChange={(e) => {
                          let elem = { ...ele };
                          if (elem?.status) {
                            elem.status = e.target.value;
                            handleUpdateTableData(elem, ele); // 1st param is for new object, and 2nd is for old object
                          }
                        }}
                        label="Status"
                        className={`navigo-dashboard-select-css navigo-status-selector ${`${
                          ele?.status === 1
                            ? "closed-class"
                            : `${
                                ele?.status === 2
                                  ? "invalid-class"
                                  : "progress-class"
                              }`
                        }`}`}
                      >
                        <MenuItem
                          value={1}
                          style={{
                            borderBottom: "1px solid #d8d8d8",
                            borderTopLeftRadius: "8px",
                            borderTopRightRadius: "8px",
                            fontWeight: "600",
                            paddingLeft: "5px",
                            fontFamily: "Montserrat",
                          }}
                          disabled={false}
                        >
                          Active
                        </MenuItem>
                        <MenuItem
                          value={2}
                          style={{
                            borderBottom: "1px solid #d8d8d8",
                            borderTopLeftRadius: "8px",
                            borderTopRightRadius: "8px",
                            fontWeight: "600",
                            paddingLeft: "5px",
                            fontFamily: "Montserrat",
                          }}
                          disabled={false}
                        >
                          Inactive
                        </MenuItem>
                      </Select>
                    }
                  </div>

                  {Boolean(cityMappingOperationSelected === 2) && (
                    <IconButton
                      onClick={(e) => {
                        if (handleUpdateTableData != null) {
                          let elem = { ...ele };
                          if (elem?.status) {
                            elem.status = 3;
                            handleUpdateTableData(elem, ele); // 1st param is for new object, and 2nd is for old object
                          }
                        }
                      }}
                      className="navigo-appoint-section-6-grid-edit-call"
                    >
                      <DeleteIcon
                        style={{
                          // fontSize: "10em",
                          color: "orange",
                        }}
                      />
                    </IconButton>
                  )}
                </div>
              );
            })}
        </div>
        {loading && <GlobalSkeletonLoader />}
        {loading === false &&
          (tableData?.length ?? 0) <= 0 &&
          (newTableData?.length ?? 0) <= 0 && (
            <h3 style={{ width: "100%", textAlign: "center" }}>
              No cities found!
              <br /> Click on "Add cities" to add them.
            </h3>
          )}

        {Boolean((cityMappings?.cityEntities ?? []).length > 0) && (
          <div className="navigo-appoint-bottom-bar">
            <Button
              onClick={() => {
                navigateToPrevPage();
              }}
              disabled={pageNum <= 1 || loading}
            >
              <FontIcon>arrow_left</FontIcon>
            </Button>
            <div style={{ display: "flex", flexDirection: "row" }}>
              Showing&nbsp;
              <span
                style={{
                  color: "#ef7c01",
                  display: "flex",
                  flexDirection: "row",
                }}
              >
                {totalCount == 0 ? 0 : (pageNum - 1) * pageSize + 1}&nbsp;
              </span>
              <span
                style={{
                  color: "#ef7c01",
                  display: "flex",
                  flexDirection: "row",
                }}
              >
                - &nbsp;
                {totalCount > pageNum * pageSize
                  ? pageNum * pageSize
                  : totalCount}
              </span>
              <span>&nbsp;&nbsp;of&nbsp;</span>
              <span>{` ${totalCount}`}</span>
            </div>
            <Button
              onClick={() => {
                navigateToNextPage();
              }}
              disabled={
                loading ||
                pageNum * pageSize > totalCount ||
                (totalCount > pageNum * pageSize
                  ? pageNum * pageSize
                  : totalCount) == totalCount
              }
            >
              <FontIcon>arrow_right</FontIcon>
            </Button>
          </div>
        )}
      </div>
      {openBackdrop && (
        <div
          className="navigo-appointment-backdrop-class"
          onClick={() => {
            setOpenFilter(0);
            setOpenBackdrop(false);
          }}
        ></div>
      )}
    </div>
  );
};

export default CityTable;
